import { z } from 'zod'
import { AttachmentIdSchema, CompanyIdSchema, LocationIdSchema, UserIdSchema } from '../ids'
import { AuditPropsSchema } from '../common'

export const AttachmentStatusSchema = z.enum(['pending', 'valid', 'corrupted'])
export type AttachmentStatus = z.infer<typeof AttachmentStatusSchema>
export const ALLOWED_ATTACHMENT_MIME_TYPES: string[] = [
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/gif',
  'image/webp',
  'image/avif',
  'image/heic',
  'image/heif',
  'image/tiff',
  'image/bmp',
  'video/mp4',
  'video/quicktime',
  'video/webm',
  'video/mpeg',
  'video/x-msvideo',
  'video/3gpp',
  'audio/mpeg',
  'audio/mp4',
  'audio/ogg',
  'audio/wav',
  'audio/webm',
  'audio/aac',
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/rtf',
  'text/plain',
  'text/csv',
  'application/json',
  'application/vnd.oasis.opendocument.text',
  'application/vnd.oasis.opendocument.spreadsheet',
  'application/zip',
  'application/vnd.rar',
  'application/x-rar-compressed',
  'application/x-7z-compressed',
]

export const UnsavedAttachmentSchema = z.object({
  filename: z.string(),
  contentType: z.string(),
  size: z.number().optional(),
  locationId: LocationIdSchema.optional(),
})

export type UnsavedAttachment = z.infer<typeof UnsavedAttachmentSchema>

export const AttachmentDataSchema = z.object({
  ...AuditPropsSchema.shape,
  ...UnsavedAttachmentSchema.shape,
  attachmentId: AttachmentIdSchema,
  userId: UserIdSchema,
  companyId: CompanyIdSchema,
  downloadUrl: z.string(),
  checksum: z.string().optional(),
  expiresAt: z.number().optional(),
  uploadedAt: z.number().optional(),
  status: AttachmentStatusSchema.optional().default('pending'),
})
export type AttachmentData = z.infer<typeof AttachmentDataSchema>
